module.exports = __webpack_public_path__ + "static/media/42.8409d0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/42.jpg
// module id = 411
// module chunks = 0